import { FC, useEffect, useState } from "react";
import "../zommedCar/ZoomedCarComponentStyles.scss";
import Icons from "../../../../../assets/Icons";
import LoadingColserauto from "./LoadingColserauto";
import { API_URL } from "../../../../../../../config/env";

interface PreviewImageProps {
    close: () => void;
    idColserauto?: string;
    /** imageUrl y plate los siguen pasando las páginas; este visor ya solo muestra PDF/Colserauto. */
    imageUrl?: string;
    plate?: string;
    /** Se conserva por compatibilidad con quienes lo pasan; el peritaje de Automás ya no se resuelve aquí. */
    automas?: boolean;
    automasPdf?: string | null;
    onNoData?: () => void;
}

const PreviewImage: FC<PreviewImageProps> = ({ idColserauto, close, automasPdf, onNoData }) => {
    const [pdfImageUrl, setPdfImageUrl] = useState<string | null>(null);
    const [zoomLevel, setZoomLevel] = useState<number>(1);
    const [hasContentLoaded, setHasContentLoaded] = useState(false);
    const [showLoader, setShowLoader] = useState(true);

    // Cuando el vehículo trae su propio peritaje en PDF (automas_pdf) se muestra ese documento
    // y se omiten por completo los peritajes de Colserauto / Automas.
    const hasAutomasPdf = Boolean(automasPdf);

    useEffect(() => {
        if (hasAutomasPdf) return;
        if (idColserauto) {
            const fetchPdfImage = async () => {
                try {
                    const response = await fetch(
                        `${API_URL}/create-image-colserauto/${idColserauto}/`,
                    );
                    if (!response.ok) {
                        throw new Error("Failed to fetch PDF image");
                    }
                    const blob = await response.blob();
                    const url = URL.createObjectURL(blob);
                    setPdfImageUrl(url);
                    setHasContentLoaded(true);
                } catch (error) {
                    console.error("Error fetching PDF image:", error);
                    setShowLoader(false);
                    setHasContentLoaded(false);
                    onNoData?.();
                }
            };

            fetchPdfImage();
            return;
        }
        onNoData?.();
    }, [idColserauto, hasAutomasPdf]);

    useEffect(() => {
        // Cuando el contenido está listo
        if (hasContentLoaded) {
            // Establece un temporizador para desmontar *después* del fade-out CSS
            const fadeOutTimer = setTimeout(() => {
                setShowLoader(false); // <--- Desmonta el loader SOLO después del tiempo de transición
            }, 800); // 800 milisegundos

            return () => clearTimeout(fadeOutTimer);
        }
    }, [hasContentLoaded]);

    const handleZoomIn = () => {
        setZoomLevel((prev) => Math.min(prev + 0.25, 3)); // Max zoom: 3x
    };
    const handleZoomOut = () => {
        setZoomLevel((prev) => Math.max(prev - 0.25, 0.5)); // Min zoom: 0.5x
    };
    return (
        <div className="zoom_car_component">
            <div className="close hover z-index-10" onClick={close}>
                <Icons.Clear />
            </div>
            <div className="zoom_car_component_image_container">
                <div className="closer" onClick={close}></div>
                <div
                    style={{
                        position: "absolute",
                        top: 10,

                        right: "50%",
                        left: "50%",
                        margin: "auto",
                        display: hasAutomasPdf ? "none" : "flex",
                        gap: 10,
                        zIndex: 100,
                    }}
                >
                    <button
                        onClick={handleZoomIn}
                        style={{
                            backgroundColor: "#FF7300",
                            color: "white",
                            border: "none",
                            padding: "5px 10px",
                            borderRadius: 5,
                            cursor: "pointer",
                            fontSize: 20,
                            fontWeight: 700,
                        }}
                    >
                        +
                    </button>
                    <button
                        onClick={handleZoomOut}
                        style={{
                            backgroundColor: "#FF7300",
                            color: "white",
                            border: "none",
                            padding: "5px 10px",
                            borderRadius: 5,
                            cursor: "pointer",
                            fontSize: 20,
                            fontWeight: 700,
                        }}
                    >
                        -
                    </button>
                </div>
                {hasAutomasPdf ? (
                    <iframe
                        title="Peritaje del vehículo"
                        className="pdf-viewer"
                        src={automasPdf as string}
                        style={{ border: "none", backgroundColor: "#fff" }}
                    />
                ) : idColserauto ? (
                    <>
                        {pdfImageUrl && (
                            <div
                                style={{
                                    position: "relative",
                                    overflow: "auto",
                                    maxWidth: "100%",
                                    maxHeight: "100%",
                                    marginTop: 60,
                                }}
                            >
                                <img
                                    src={pdfImageUrl || "/assets/placeholder.png"}
                                    alt="PDF Page"
                                    className="pdf-viewer"
                                    style={{
                                        width: "auto",
                                        height: "auto",
                                        transform: `scale(${zoomLevel})`,
                                        transformOrigin: "top left",
                                    }}
                                />
                            </div>
                        )}

                        {showLoader && (
                            <div>
                                <LoadingColserauto isDone={hasContentLoaded} />
                            </div>
                        )}
                    </>
                ) : null}
            </div>
        </div>
    );
};

export default PreviewImage;
